import { Drawer, Box, Stack, Typography, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  open: boolean;
  onClose: () => void;
  payload: unknown;
};

export default function TechInsightsDrawer({ open, onClose, payload }: Props) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: '100%', sm: 520 } } }}>
      <Box sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Insights técnicos
          </Typography>
          <IconButton onClick={onClose} aria-label="Cerrar">
            <CloseIcon />
          </IconButton>
        </Stack>

        <Typography variant="body2" sx={{ opacity: 0.75, mt: 0.5 }}>
          Solo para diagnóstico. No es para uso ejecutivo.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Box
          component="pre"
          sx={{
            m: 0,
            p: 1.5,
            borderRadius: 2,
            bgcolor: 'rgba(15,23,42,0.06)',
            border: '1px solid rgba(0,0,0,0.08)',
            overflow: 'auto',
            maxHeight: 'calc(100vh - 160px)',
            fontSize: 12,
            lineHeight: 1.45,
          }}
        >
          {JSON.stringify(payload, null, 2)}
        </Box>
      </Box>
    </Drawer>
  );
}